export interface PublicCurrencyDTO {
  Code: string;
  CurrencyName: string;
  CurrencyNumber: number;
  CurrencyDecimalPositions: number;
  ID: string;
  ExchangeRateListID: string;
}
